import React from 'react';
import './fileUpload.scss';
import loadingImg from '../../assets/images/loading-white.svg'
import { fieldValidationMessage } from '../../helper/constants';
import { limiteTamanhoArquivo } from '../../helper/constants';
import Utils from "../../helper/validateUtils";
import { tipoDocImagem } from '../../helper/constants';

import Popover from '../../components/popover';
import iconInfo from '../../assets/images/icon_info.svg';

const initialState = {
  text: "Escolher um arquivo",
  value: "",
  loading: false,
  file: null,
  errorDescription: null,
  active: false,
  fileType: "",
  documentType: 0,
  idGrupoDocumento: 0,
  imageType: 0,
  base64: "",
  IdDocumentoArquivo: '',
  documents: [],
  deleteAll: false,
  errorNotification: null
};

class FileUpload extends React.Component {

  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = { ...initialState };

    this.handleChange = this.handleChange.bind(this);
    this.handleAddImage = this.handleAddImage.bind(this);
    this.handleCancelUpload = this.handleCancelUpload.bind(this);
    this.validateAsync = this.validateAsync.bind(this);
    this.isValue = this.isValue.bind(this);

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentWillMount() {
    let { returnObject } = this.props;

    if (returnObject) {
      returnObject(this)
    }
  }

  componentDidMount() {
    this._isMounted = true;
    let { base64 } = this.props;
    if (base64) {
      this.setState({ base64 })
    }
  }

  componentWillReceiveProps(nextProps) {
    let { base64, documents } = nextProps;
    if (base64) {
      this.setState({ base64 })
    }
    if (documents === null || documents === undefined || documents.length === 0) {
      this.setState({ base64, value: '' })
    }
  }

  isValue = () => {
    let { value, base64 } = this.props;
    return value || base64 || this.state.value || this.state.loading
  }

  render() {

    let { value, loading, errorDescription } = this.state;
    let { handleAddImage, handleChange, handleCancelUpload, isValue } = this;
    let { textFile, subText, required, asyncLoading, errorMessage, disable, onlyOneArchive, multiple } = this.props;

    // Mostrar mensagem de erro 
    let errorNotification = errorDescription || errorMessage;

    let activeClass = isValue() || loading || asyncLoading ? "active" : "notActive";

    return (
      <div className="col component-upload">
        <div className="col-60">
          <p>{textFile}{required ? " *" : ""}</p>
        </div>
        <div className="col-5">
          {subText && (
              <div className="popover">
                <Popover message={subText}
                  icon={iconInfo} />
              </div>
          )}
        </div>
        <div className="col-35">
          <div className="fileUpload">
            <li className={` ${activeClass} fileUpload-item `}>
              <div className="input-group">
                <input
                  ref={input => { this.input = input }}
                  title=""
                  accept="image/*,application/pdf"
                  className="fileUpload-input"
                  onDrop={handleAddImage}
                  onChange={handleChange}
                  disabled={(asyncLoading || loading || disable)}
                  type="file"
                  value={value}
                  multiple={multiple}
                />
                <label>{ !activeClass || onlyOneArchive ? 'Escolher um arquivo' : "Anexar mais arquivos" }</label>
                <span className="input-group-btn">
                  {(isValue() || asyncLoading) &&
                    <button
                      className="cancel-upload-button"
                      onClick={handleCancelUpload} 
                      type="button"
                      disabled={asyncLoading}
                      >
                    </button>}
                </span>
                {(asyncLoading || loading) && <i className="icon"> <img src={loadingImg} alt="loading" /></i>}
              </div>
            </li>
          </div>
        </div>
        {errorNotification &&
          <div className="col-66 error-notification">
            <p>{errorNotification}</p>
          </div>}
      </div>
    );
  }

  notifyValue() {
    let { value, base64, fileType, text, documents, file, active, IdDocumentoArquivo, deleteAll, errorNotification } = this.state;
    let { onChange, id, documentType, imageType, idGrupoDocumento, nameDocs } = this.props;
    onChange({ value, fileType, documentType, idGrupoDocumento, imageType, base64, text, id, documents, file, active, IdDocumentoArquivo, nameDocs, deleteAll, errorNotification });
  }

  handleChange(event) {
    this.handleAddImage(event);
    this.validate(event.target);
  }

  handleAddImage(element) {
    element.preventDefault();
    let file = element.target.files[0];
    let { listTypeArquivo, documents, limit, imageType } = this.props;

    if (!file) {
      this.setState({ ...initialState }, () => {
        this.validate(element.target);
        this.notifyValue()
      });
      return;
    }
    // Validar limite qtd Arquivos
    if (limit && documents && documents.length + 1 > limit) {
      this.setState({
        file: null,
        errorNotification: `É permitido anexar no máximo ${limit} arquivo(s) para esse tipo de documento.`,
        value: ""
      }, () => this.notifyValue());
      return;
    }

    const isIdentity = imageType === tipoDocImagem.Frente || imageType === tipoDocImagem.Verso;
    if (Utils.validarTamanhoArq(isIdentity, file)) {
      this.setState({
        file: null,
        errorNotification: `Tamanho do arquivo maior que o limite ${isIdentity ? limiteTamanhoArquivo.Identificacao : limiteTamanhoArquivo.Outros}MB.`,
        value: "",
      }, () => this.notifyValue());

      return false;
    }

    // Validar arquivo se é do tipo imagem
    let fileType = file.type.split('/')[1];

    let checkDocument = listTypeArquivo.find(item => item.toUpperCase() === fileType.toUpperCase());

    if (!checkDocument) {
      this.setState({
        file: null,
        errorNotification: "Não é um arquivo Valido!",
        value: "",
      }, () => this.notifyValue());

      return false;
    }

    this.getBase64(file).then(result => {

      let { value, fileType } = this.state;

      this.setState({
        value: value,
        fileType: fileType,
        base64: result
      }, () => this.notifyValue());

    }).catch((error) => {

      this.setState({
        file: null,
        errorNotification: "Não é um arquivo Valido!",
        value: ""
      }, () => this.notifyValue());
    });

    this.setState({
      file: file,
      text: file.name,
      active: true,
      errorNotification: null,
      value: element.target.value,
      fileType: checkDocument
    });

    this.validate(element.target);
  }

  //Cancel Imagem
  handleCancelUpload(element) {
    element.preventDefault();
    this.setState({
      file: null,
      text: "Escolher um arquivo",
      value: "",
      base64: "",
      active: false,
      documents: [],
      IdDocumentoArquivo: '',
      deleteAll: true
    }, () => this.notifyValue());
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  checkValidity = () => {
    let { required, value } = this.props;

    if (required) {
      if (!value) {
        this.input.validity = {
          valueMissing: true
        }
        return false;
      } else {
        this.input.validity = {}

      }
    }
    return true;
  }

  validate = field => {
    let fieldValidityState = null;
    let { required, base64 } = this.props;

    return new Promise((resolve, reject) => {


      if (required) {
        let content = this.input.value || base64
        if (!content) {
          fieldValidityState = {
            valueMissing: true
          }
          let errorType = this.validatePropertiesValidityState(fieldValidityState)
          reject({ message: fieldValidationMessage[errorType]({ ...this.props, ...this.state }) })
        }
      }

      let resultValidateSync = this.validateSync(this.input.value)
      if (resultValidateSync !== true)
        reject(resultValidateSync)

      this.setState({ asyncLoading: true })
      resolve(this.input.value)
    })
      .then(this.validateAsync)
      .then(() => {
        this.setState({ className: 'info', errorDescription: '' })
        //field.setCustomValidity('')
        return true
      })
      .catch(error => {
        this.setState({ className: 'danger', errorDescription: error.message })
        let { onError } = this.props
        if (onError)
          onError({ name: this.state.name, errorDescription: error.message })

        return false
      }).finally(() => {
        this.setState({ asyncLoading: false })
        return this.state
      })
  }

  async validateAsync(value) {
    if (typeof (this.props.validateAsync) === "function")
      return await this.props.validateAsync(value)
    return true
  }

  validateSync = value => {
    if (!this.props.validateSync)
      return true

    return this.props.validateSync(value)
  }


  validatePropertiesValidityState = validityState => {
    for (var key in validityState) {
      if (validityState[key] === true && key !== 'valid')
        return key
    }

  }
}

export default FileUpload;


